import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-arrow-left',
  imports: [],
  templateUrl: './arrow-left.html',
})
export class ArrowLeft {
  @Input() size: 'm' | 'l' = 'm';
}
